// src/utils/visitChecklistTemplates.js
// Templates par défaut pour la checklist de visite.
// Stockage : maison.visitChecklist = [{ id, section, label, checked, note, custom? }, ...]

export const CHECKLIST_TEMPLATE_RP = [
  // Extérieur
  { id: "rp-ext-facade", section: "Extérieur", label: "État de la façade (fissures, ravalement à prévoir ?)" },
  { id: "rp-ext-toiture", section: "Extérieur", label: "Toiture (état apparent, tuiles/ardoises)" },
  { id: "rp-ext-jardin", section: "Extérieur", label: "Jardin / Terrain (entretien, ensoleillement)" },
  { id: "rp-ext-parking", section: "Extérieur", label: "Stationnement / Garage" },
  { id: "rp-ext-mitoyen", section: "Extérieur", label: "Vis-à-vis / Mitoyenneté" },
  // Intérieur
  { id: "rp-int-murs", section: "Intérieur", label: "État murs/plafonds (fissures, peinture)" },
  { id: "rp-int-sols", section: "Intérieur", label: "État des sols (parquet, carrelage, usure)" },
  { id: "rp-int-cuisine", section: "Intérieur", label: "Cuisine (équipement, plan de travail, état)" },
  { id: "rp-int-sdb", section: "Intérieur", label: "Salle(s) de bain (douche/baignoire, ventilation)" },
  { id: "rp-int-rangements", section: "Intérieur", label: "Rangements / Placards / Dressing" },
  { id: "rp-int-lumiere", section: "Intérieur", label: "Luminosité par pièce (orientation, fenêtres)" },
  // Technique
  { id: "rp-tech-chauffage", section: "Technique", label: "Chauffage (type, âge de la chaudière, état)" },
  { id: "rp-tech-isolation", section: "Technique", label: "Isolation (ressenti murs, qualité des fenêtres)" },
  { id: "rp-tech-plomberie", section: "Technique", label: "Plomberie (test eau chaude/froide, pression)" },
  { id: "rp-tech-elec", section: "Technique", label: "Électricité (état du tableau, nb de prises)" },
  { id: "rp-tech-humidite", section: "Technique", label: "Humidité / Moisissures / Salpêtre" },
  // Environnement
  { id: "rp-env-voisinage", section: "Environnement", label: "Voisinage (bruit, civilités)" },
  { id: "rp-env-transports", section: "Environnement", label: "Transports en commun (proximité, fréquence)" },
  { id: "rp-env-commerces", section: "Environnement", label: "Commerces / Écoles / Services" },
  { id: "rp-env-nuisances", section: "Environnement", label: "Nuisances (route, train, avion, industrie)" },
];

export const CHECKLIST_TEMPLATE_INVEST = [
  // Extérieur
  { id: "inv-ext-facade", section: "Extérieur", label: "État façade (impact attractivité locataire)" },
  { id: "inv-ext-parking", section: "Extérieur", label: "Stationnement (critique pour louer dans certains secteurs)" },
  { id: "inv-ext-espaces", section: "Extérieur", label: "Espaces extérieurs (balcon, terrasse, jardin partagé)" },
  // Intérieur
  { id: "inv-int-general", section: "Intérieur", label: "État général (travaux à prévoir avant mise en location ?)" },
  { id: "inv-int-cuisine", section: "Intérieur", label: "Cuisine (équipée / meublée ? loyer meublé possible ?)" },
  { id: "inv-int-sdb", section: "Intérieur", label: "Salle de bain (modernité, attractivité)" },
  { id: "inv-int-config", section: "Intérieur", label: "Configuration (T1/T2/T3 adaptée à la demande locale)" },
  // Technique
  { id: "inv-tech-dpe", section: "Technique", label: "🚨 DPE et loi climat (G interdit dès 2025, F en 2028)" },
  { id: "inv-tech-chauffage", section: "Technique", label: "Chauffage (collectif/individuel, qui paie ?)" },
  { id: "inv-tech-isolation", section: "Technique", label: "Isolation (impact direct sur charges locataire)" },
  { id: "inv-tech-elec", section: "Technique", label: "Électricité (norme NF C 15-100 ? coût mise aux normes)" },
  { id: "inv-tech-diagnostics", section: "Technique", label: "Diagnostics fournis (amiante, plomb, gaz, élec)" },
  // Rentabilité & marché locatif
  { id: "inv-rent-demande", section: "Rentabilité & marché locatif", label: "Type de bien demandé localement (étudiant, jeune actif, famille...)" },
  { id: "inv-rent-tension", section: "Rentabilité & marché locatif", label: "Tension locative du secteur (demande > offre ?)" },
  { id: "inv-rent-charges", section: "Rentabilité & marché locatif", label: "Charges de copropriété (montant annuel, récupérables vs non)" },
  { id: "inv-rent-travaux", section: "Rentabilité & marché locatif", label: "Travaux votés en AG / à prévoir (toiture, ravalement, ascenseur)" },
  { id: "inv-rent-pinel", section: "Rentabilité & marché locatif", label: "Plafond loyer Pinel/Pinel+ si applicable" },
  { id: "inv-rent-concurrence", section: "Rentabilité & marché locatif", label: "Concurrence locative (autres biens similaires en location)" },
];

// Ordre canonique d'affichage des sections (pour rendu stable)
export const SECTION_ORDER_RP = ["Extérieur", "Intérieur", "Technique", "Environnement"];
export const SECTION_ORDER_INVEST = ["Extérieur", "Intérieur", "Technique", "Rentabilité & marché locatif"];

// Renvoie une copie fraîche du template, prête à être modifiée (checked/note vides).
export function getDefaultChecklist(usage) {
  const template = usage === "investissement" ? CHECKLIST_TEMPLATE_INVEST : CHECKLIST_TEMPLATE_RP;
  return template.map((item) => ({ ...item, checked: false, note: "" }));
}

export function getSectionOrder(usage) {
  return usage === "investissement" ? SECTION_ORDER_INVEST : SECTION_ORDER_RP;
}

// Petit utilitaire pour la barre de progression et l'indicateur de carte.
export function checklistProgress(checklist) {
  if (!Array.isArray(checklist) || checklist.length === 0) return { done: 0, total: 0 };
  return {
    done: checklist.filter((i) => i.checked).length,
    total: checklist.length,
  };
}
